import React, { Component } from "react";
import { ajaxWrapper } from "functions";

export default class SpellHigher extends React.Component {
	render() {
		var spell = this.props.spell;

		return (
			<div className="col-12">
				{spell.spell_specifics.higher_level_description ? (
					<div>
						<p style={{ whiteSpace: "break-spaces", lineHeight: "normal", textIndent: "15px" }}>
							<b>At Higher Levels: </b> {spell.spell_specifics.higher_level_description}
						</p>
						<br />
					</div>
				) : null}
			</div>
		);
	}
}
